// components/CookieConsent.jsx
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Box, Typography, Button, Link } from '@mui/material';
import './cookieBanner.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookieConsent');
    if (!consent) setVisible(true);
  }, []);

  const handleConsent = (accepted) => {
    Cookies.set('cookieConsent', accepted ? 'accepted' : 'refused', { expires: 180 });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box className="cookie-banner">
      <Typography variant="body2">
        Nous utilisons des cookies techniques et statistiques pour améliorer votre expérience et nos services.
      </Typography>
      <Typography variant="body2" sx={{ marginTop: '8px' }}>
        Vous avez la possibilité de les personnaliser à tout moment via notre bandeau cookies, pour plus d’informations, 
        nous vous invitons à consulter{" "}
        <Link href="/politique-cookies" underline="hover" color="primary">
          notre politique cookies
        </Link>.
      </Typography>

      <Box className="cookie-buttons">
        <Button
          variant="outlined"
          onClick={() => handleConsent(true)}
          className="cookie-button"
        >
          Accepter
        </Button>
        <Button
          variant="outlined"
          onClick={() => handleConsent(false)}
          className="cookie-button"
        >
          Refuser
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsent;
